/** * Created by lobin on 2019/2/1. */
<template>
  <div class="work-edit">
    <el-form
      :model="workExperience"
      ref="workExperience"
      label-width="100px"
      class="myresume-form"
      :rules="rules"
      label-position="left"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="公司名称：" prop="companyName">
            <el-input
              v-model="workExperience.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="工作地点：" prop="workAreaId">
            <el-input
              maxlength="6"
              v-model="workExperience.workAreaId"
              placeholder="请输入工作地点"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="职位类别：" prop="positionType">
            <el-select
              v-model="workExperience.positionType"
              placeholder="请选择职位类别"
            >
              <el-option
                :label="item.name"
                v-for="item in positionType"
                :key="item.name"
                :value="item.code"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="职位名称：" prop="positionName">
            <el-input
              v-model="workExperience.positionName"
              placeholder="请输入职位名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="开始时间：" prop="startDate">
            <el-date-picker
              type="month"
              placeholder="开始时间"
              v-model="workExperience.startDate"
              value-format="yyyy-MM"
              :picker-options="pickerOptionsStart"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="结束时间：" required>
            <el-row>
              <el-col :span="18">
                <el-date-picker
                  type="month"
                  placeholder="结束时间"
                  :disabled="endDate"
                  v-model="workExperience.endDate"
                  :picker-options="pickerOptionsEnd"
                  value-format="yyyy-MM"
                  style="width: 100%;"
                ></el-date-picker>
              </el-col>
              <el-col :span="6">
                <el-checkbox
                  v-model="endDate"
                  style="margin-left: 10px"
                  @change="selectToday"
                  >至今</el-checkbox
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工作内容：" prop="workContent">
            <quill-editor
              v-model="workExperience.workContent"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主要业绩：" prop="achievement">
            <quill-editor
              v-model="workExperience.achievement"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="text-align: center">
          <el-button @click="next">{{ cancelText }}</el-button>
          <el-button type="primary" @click="addAction">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["value", "index", "type", "cancelText"],
  data() {
    return {
      endDate: false,
      editorOption: {},
      workExperience: {}
    };
  },
  created() {
    if (this.value.endDate == "1970-01") {
      this.workExperience = Object.assign(this.value, { endDate: new Date() });
      this.endDate = true;
    }
    this.workExperience = this.value;
  },
  computed: {
    ...mapGetters(["positionType"]),
    // pickerOptionsStart(){
    //   const endDate = this.workExperience.endDate;
    //   return {
    //     disabledDate(time){
    //       if(endDate){
    //         if(this.endDate){
    //           return time.getTime() > Date.now() - 8.64e6;
    //         }
    //         return time.getTime() >  new Date(endDate).getTime();
    //       }
    //       return time.getTime() > Date.now() - 8.64e6;
    //     }
    //   }
    // },
    // pickerOptionsEnd(){
    //   return {
    //     disabledDate(time){
    //       return time.getTime() > Date.now() - 8.64e6;
    //     }
    //   }
    // },
    // 时间结束判断
    pickerOptionsEnd() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.workExperience.startDate) {
            return (
              time.getTime() <=
                new Date(_this.workExperience.startDate).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      };
    },
    // 时间起始判断
    pickerOptionsStart() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.workExperience.endDate) {
            return (
              time.getTime() >=
                new Date(_this.workExperience.endDate).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      };
    },
    rules() {
      return {
        companyName: [
          { required: true, trigger: "blur", message: "学校公司必填" }
        ],
        workAreaId: [
          { required: true, trigger: "blur", message: "工作地点必填" }
        ],
        positionType: [
          { required: true, trigger: "change", message: "职位类别必填" }
        ],
        positionName: [
          { required: true, trigger: "blur", message: "职位名称必填" }
        ],
        startDate: [
          { required: true, trigger: "change", message: "开始时间必填" }
        ],
        endDate: [
          { required: true, trigger: "change", message: "结束时间必填" }
        ],
        workContent: [
          { required: true, trigger: "change", message: "工作内容必填" }
        ],
        achievement: [
          { required: true, trigger: "change", message: "主要业绩必填" }
        ]
      };
    },
    educationRules() {
      return {};
    }
  },
  methods: {
    ...mapActions(["addWorkExperience", "editWorkExperience"]),
    async addAction() {
      const validate = await this.$refs["workExperience"].validate();
      if (!validate) return;
      const actionType =
        this.type == "edit" ? "editWorkExperience" : "addWorkExperience";
      const data = Object.assign({}, this.workExperience);
      console.log(data);

      if (this.endDate) {
        data.endDate = "1970-01";
      }
      const res = await this[actionType](data);
      if (res.code === 200) {
        if (this.type !== "edit") {
          this.$emit("input", res.data);
        }
        this.$emit("submit", { index: this.index });
        this.$message.success("成功");
      } else {
        this.$message.error(res.message);
      }
    },
    selectToday() {
      if (this.endDate) {
        this.workExperience.endDate = new Date();
      }
    },
    async next() {
      this.$emit("submit", { index: this.index, type: "skip" });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.work-edit{
  background: #F2F6FA;
  border-radius: 6px;
  padding: 24px;
}
</style>
